import { Component, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { ConfigService } from '../../../../core/utils/config-service';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CvthequeService } from '../../../../core/services/cvtheque.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { UploadService } from '../../../../core/services/upload.service';
import { StatusComponent } from '../../component/status/status.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-cvtheque',
  standalone: true,
  imports: [
      CommonModule,
                FormsModule,
                NgbModule,
                NgxPaginationModule,
                LoadingComponent,
                SampleSearchPipe,
                StatusComponent,
                NgxExtendedPdfViewerModule
  ],
  templateUrl: './cvtheque.component.html',
  styleUrl: './cvtheque.component.css',
  encapsulation:ViewEncapsulation.None
})
export class CvthequeComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
 buttonsPermission :any|undefined;
  structures:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  windows:any[] =[]
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  can_generated = 0
  is_active=null
  loading=false
  tag="Categories"
  permissionName=""
    search_text=""
    skill=""
    language=""
    cv_file=""
    skills:any[]=[]
    languages:any[]=[]
role:any
  user:any
  loading2=false
pg={
    pageSize:10,
    p:0,
    total:0
  }
  fileInput:any; 
  baseUrl=ConfigService.toFile('storage');

  


  constructor(
    private uploadService: UploadService,
    private cvService: CvthequeService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
  
  }

 

  getAll(){
    this.loading2=true

    this.cvService.getAll().subscribe((res:any)=>{
      this.data=res.data 
    this.pg.pageSize=10
    this.pg.p=0
    this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }


  store(value:any){
    this.loading=true
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }
    formData.append('skills',JSON.stringify(this.skills))
    formData.append('language',JSON.stringify(this.languages))

    if (this.fileInput!=undefined) {
      formData.append('cv_file',this.fileInput)
    }
    this.cvService.store(formData).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update(value:any){
    this.loading=true
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    formData.append('skills',JSON.stringify(this.skills))
    formData.append('language',JSON.stringify(this.languages))

    if (this.fileInput!=undefined) {
      formData.append('file',this.fileInput)
    }
    this.cvService.update(this.selected_data.id,formData).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.cvService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.skills=JSON.parse(el.skills)
    this.languages=JSON.parse(el.language)
    this.is_active=el.is_active
    this.can_generated=el.can_generated
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
      // let formData= new FormData();
      // formData.append('input',this.fileInput);
      // this.loading=true
      // this.uploadService.store(formData).subscribe((res:any)=>{
      //   console.log(res)
      //   this.cv_file=res.full_url
      //   this.toastrService.success(res.message)
      //   this.loading=false

      // },
      // (err:any)=>{
      //   this.loading=false
      //   console.log(err)
      //   AppErrorShow.showError("Gestion des rôles",err)
      // })
    }
  }

  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }


  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
  }

  setName(ev:any){
    this.permissionName=this.windows[ev.target.value].name
    this.selectedWindow=this.windows[ev.target.value]
  }

  setValue(i:any){
    this.roles[i].value= !this.roles[i].value
  }

  getJson(actions:any){
    return JSON.parse(actions)
  }

  getPage(event:any){
    this.pg.p=event
  }

  addSkill(){
    this.skills.push(this.skill)
    this.skill="";
  }

  removeSkill(i:any){
    this.skills.splice(i,1)
  }
  addLanguage(){
    this.languages.push(this.language)
    this.language="";
  }

  removeLanguage(i:any){
    this.languages.splice(i,1)
  }

  open(path:any){
    this.pdfSrc=path
    console.log(this.pdfSrc)
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  }
}
